import "core-js/modules/es.function.name";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */

/* eslint-disable wf-security/no-location-href */
export var WORKFLOW_START = 'WORKFLOW_START';
export var WORKFLOW_INITIALIZE = 'WORKFLOW_INITIALIZE';
export var WORKFLOW_UPDATE_PATH_FOR_VIEW = 'WORKFLOW_UPDATE_PATH_FOR_VIEW';
export var WORKFLOW_UPDATE_VIEW_FOR_PATH = 'WORKFLOW_UPDATE_VIEW_FOR_PATH';
export var WORKFLOW_ABANDON = 'WORKFLOW_ABANDON';
export var WORKFLOW_SHOW_VIEW = 'WORKFLOW_SHOW_VIEW';
export var WORKFLOW_RETURN_TO_VIEW = 'WORKFLOW_RETURN_TO_VIEW';
export var WORKFLOW_RETURN_TO_PREVIOUS_VIEW = 'WORKFLOW_RETURN_TO_PREVIOUS_VIEW';
export var WORKFLOW_CHECKPOINT = 'WORKFLOW_CHECKPOINT';
export var WORKFLOW_END = 'WORKFLOW_END';
export var WORKFLOW_CLEAN = 'WORKFLOW_CLEAN';
export var WORKFLOW_VIEW_CHANGED = 'WORKFLOW_VIEW_CHANGED';
export var WORKFLOW_SET_IGNORE_NEXT_PATH_CHANGE = 'WORKFLOW_SET_IGNORE_NEXT_PATH_CHANGE';
export var startWorkflow = function startWorkflow(_ref) {
  var name = _ref.name,
      startingView = _ref.startingView,
      _ref$pushFirstView = _ref.pushFirstView,
      pushFirstView = _ref$pushFirstView === void 0 ? false : _ref$pushFirstView;
  return {
    type: WORKFLOW_START,
    name: name,
    startingView: startingView,
    pushFirstView: pushFirstView
  };
};
export var initializeWorkflow = function initializeWorkflow(name, viewName, pushFirstView, pathnameBeforeWorkflow) {
  return {
    type: WORKFLOW_INITIALIZE,
    viewIndex: 1,
    name: name,
    viewName: viewName,
    pushFirstView: pushFirstView,
    pathnameBeforeWorkflow: pathnameBeforeWorkflow
  };
};
export var updatePathForView = function updatePathForView(_ref2) {
  var workflowName = _ref2.workflowName,
      view = _ref2.view,
      views = _ref2.views,
      navigationIndex = _ref2.navigationIndex,
      pushFirstView = _ref2.pushFirstView;
  return {
    type: WORKFLOW_UPDATE_PATH_FOR_VIEW,
    viewName: view,
    viewIndex: views.size,
    workflowName: workflowName,
    navigationIndex: navigationIndex,
    pushFirstView: pushFirstView
  };
};
export var updateViewForPath = function updateViewForPath(viewName, viewIndex, navigationIndex) {
  return {
    type: WORKFLOW_UPDATE_VIEW_FOR_PATH,
    viewName: viewName,
    viewIndex: viewIndex,
    navigationIndex: navigationIndex
  };
};
export var setIgnoreNextPathChange = function setIgnoreNextPathChange(ignore) {
  return {
    type: WORKFLOW_SET_IGNORE_NEXT_PATH_CHANGE,
    ignoreNextPathChange: ignore
  };
};
export var showView = function showView(viewName) {
  return {
    type: WORKFLOW_SHOW_VIEW,
    viewName: viewName
  };
};
export var returnToView = function returnToView(viewName) {
  return {
    type: WORKFLOW_RETURN_TO_VIEW,
    viewName: viewName
  };
};
export var returnToPreviousView = function returnToPreviousView() {
  return {
    type: WORKFLOW_RETURN_TO_PREVIOUS_VIEW
  };
};
export var abandonWorkflow = function abandonWorkflow() {
  return {
    type: WORKFLOW_ABANDON
  };
};
export var checkpointWorkflow = function checkpointWorkflow() {
  return {
    type: WORKFLOW_CHECKPOINT
  };
};
export var endWorkflow = function endWorkflow() {
  return {
    type: WORKFLOW_END
  };
};
export var cleanWorkflow = function cleanWorkflow() {
  return {
    type: WORKFLOW_CLEAN
  };
};
export var viewChanged = function viewChanged(_ref3) {
  var viewName = _ref3.viewName,
      viewIndex = _ref3.viewIndex,
      navigationIndex = _ref3.navigationIndex;
  return {
    type: WORKFLOW_VIEW_CHANGED,
    viewName: viewName,
    viewIndex: viewIndex,
    navigationIndex: navigationIndex
  };
};